(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nigiwai"] && !Shopify.designMode) return;
  try {
    
		var nigiwaiCount = 1;
		var orderTime;
		var num;

		// 配列初期化
		var aryNigiwaiData =  [
			{
				imgUrl:'https://cdn.shopify.com/s/files/1/0660/9167/9981/files/p_02.jpg',
				title:'1デスクトップPC Panasonic XXX-XX',
				price:'11,111',
                linkUrl:''
			},
			{
				imgUrl:'https://cdn.shopify.com/s/files/1/0660/9167/9981/files/p_03.jpg',
				title:'2デスクトップPC Panasonic XXX-XX',
				price:'22,222',
                linkUrl:''
			},
			{
				imgUrl:'https://cdn.shopify.com/s/files/1/0660/9167/9981/files/p_04.jpg',
				title:'3デスクトップPC Panasonic XXX-XX',
				price:'33,333',
                linkUrl:''
			},
			{
				imgUrl:'https://cdn.shopify.com/s/files/1/0660/9167/9981/files/p_05.jpg',
				title:'4デスクトップPC Panasonic XXX-XX',
				price:'44,444',
                linkUrl:''
			},
			{
				imgUrl:'https://cdn.shopify.com/s/files/1/0660/9167/9981/files/p_06.jpg',
				title:'5デスクトップPC Panasonic XXX-XX',
				price:'55,555',
                linkUrl:''
			},
			{
				imgUrl:'https://cdn.shopify.com/s/files/1/0660/9167/9981/files/p_07.jpg',
				title:'6デスクトップPC Panasonic XXX-XX',
				price:'66,666',
                linkUrl:''
			},
			{
				imgUrl:'https://cdn.shopify.com/s/files/1/0660/9167/9981/files/p_08.jpg',
				title:'7デスクトップPC Panasonic XXX-XX',
				price:'77,777',
                linkUrl:''
			},
		];
		
		// 配列要素数を記憶
		num = aryNigiwaiData.length;
		
		// 配列内をシャッフル
		while (num) {
			var i = Math.floor(Math.random() * num);
			var str = aryNigiwaiData[--num];
			aryNigiwaiData[num] = aryNigiwaiData[i];
			aryNigiwaiData[i] = str;
		}
		
		// にぎわいボックス追加処理
		function funcAddNigiwaiBox(dataId) {
			$('#nigiwai .box_wrap').prepend('<div class="box" style="display: none;" id="nigiwai' + nigiwaiCount + '"><div class="left"><a href="' + aryNigiwaiData[dataId].linkUrl + '"><img src="' + aryNigiwaiData[dataId].imgUrl + '" alt="' + aryNigiwaiData[dataId].title + '"></a></div><div class="right"><div class="inner_left"><a href="' + aryNigiwaiData[dataId].linkUrl + '"><h3>' + aryNigiwaiData[dataId].title + '</h3><p>【注文日時】<br>' + funcOrderTimeUpdate() + '</p></a></div><div class="inner_right">&yen;' + aryNigiwaiData[dataId].price + '（税込）</div></div></div>');
			$('#nigiwai' + nigiwaiCount).fadeIn(1000);
		}
		
		// 注文日時を初期化
		function funcInitOrderTime() {
			// 注文日時を480秒前でセット
			orderTime = new Date();
			orderTime.setSeconds(orderTime.getSeconds() - 480);
		}
		
		// 注文日時アップデート
		function funcOrderTimeUpdate() {
			var randomSec = '';
			randomSec = Math.floor( Math.random() * (15 + 1 - 1) ) + 1;
			orderTime.setSeconds(orderTime.getSeconds() + (16 + randomSec));
			return orderTime.getFullYear() + "年" + (orderTime.getMonth() + 1) + "月" + orderTime.getDate() + "日 " + orderTime.getHours() + "時" + orderTime.getMinutes() + "分" + orderTime.getSeconds() + "秒";
		}
		
		funcInitOrderTime();
		
		// インターバルタイマー
        var blnIsDeleteSystemActive = false;
		const nigiwaiId = setInterval(() => {
			funcAddNigiwaiBox(nigiwaiCount-1);
			nigiwaiCount++;
            if ( nigiwaiCount > 4 && blnIsDeleteSystemActive == false) {
              blnIsDeleteSystemActive = true;
            }
            if (blnIsDeleteSystemActive) {
              $('#nigiwai .box_wrap .box:last-of-type').remove();
            }
			if ( nigiwaiCount >= 8 ) {
				// 要素数をリセット
				nigiwaiCount = 1;
				funcInitOrderTime();
			}
		},3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
